import { appServices } from './app-services/AppServices';
import getAudioFileDuration from './getAudioFileDuration';

export async function getAudioAssetDuration(assetId: number) {
  const audioFileUrl = await appServices.getAssetUrl(assetId, false);
  const response = await fetch(audioFileUrl);
  const blob = await response.blob();
  return await getAudioFileDuration(blob);
}
